<template>
  <div class="justify-center align-center d-flex mt-12">
    <form @submit.prevent="submit">
      <h2 class="mb-3">{{ $t("organization.selectStore") }}</h2>
      <v-alert
        v-if="selectionError"
        class="mb-5"
        outlined
        type="error"
        text
      >
        {{ selectionError }}
      </v-alert>
      <v-autocomplete
        class="mb-5"
        v-model="selectedOrganization"
        :items="userOrganizations.organizations"
        item-text="Name"
        return-object
        :label="$t('anOrganization')"
        outlined
        :no-data-text="$t('noDataAvailable')"
        hide-details
        item-value="Id"
      >
        <template v-slot:item="data">
          <div>
            <div>
              <b>{{ data.item.Name }}</b>
            </div>
            <div>
              <span v-if="data.item.Street">{{ data.item.Street }}</span>
              <span v-if="data.item.PostalCode"
                >, {{ data.item.PostalCode }}</span
              >
              <span v-if="data.item.Place">, {{ data.item.Place }}</span>
              <span v-if="data.item.CountryCode"
                >, {{ data.item.CountryCode }}</span
              >
            </div>
          </div>
        </template>
      </v-autocomplete>

      <v-btn
        type="submit"
        :disabled="Object.keys(selectedOrganization).length === 0"
        width="100%"
        color="success"
      >
        {{ $t("apply") }}
      </v-btn>
    </form>
  </div>
</template>

<script>
import config from "../config";
import Axios from "axios";
// import {i18n} from '@/plugins/i18n'
import router from "@/router";
import { saveAuthSession } from "@/utils/authSession";
import { mapMutations } from "vuex";
const qs = require("querystring");

export default {
  data() {
    return {
      selectedOrganization: {},
      selectionError: "",
    };
  },
  computed: {
    userOrganizations() {
      return this.$store.getters.GET_USER_ORGANIZATIONS;
    },
  },
  methods: {
    ...mapMutations(["SET_LOGIN_USER", "SET_USER_ORGANIZATIONS"]),

    async submit() {
      this.selectionError = "";

      const payload = {
        organizationId: this.selectedOrganization.Id,
      };
      Axios.post(
        config.apiBaseUrl + "store-number/token",
        qs.stringify(payload),
        {
          headers: {
            Authorization: `Bearer ${this.userOrganizations.selectionToken}`,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            this.setUser(response.data);
          }
        })
        .catch((error) => {
          const status = error?.response?.status;
          const responseData = error?.response?.data;
          const responseMessage =
            typeof responseData === "string"
              ? responseData
              : responseData?.message;

          if (status === 401) {
            this.selectionError =
              "The organization selection session has expired. Please sign in with your Microsoft account again.";
          } else if (status === 403) {
            this.selectionError =
              responseMessage || "You do not have access to the selected organization.";
          } else if (status === 400) {
            this.selectionError =
              responseMessage || "The selected organization is not available.";
          } else {
            this.selectionError =
              responseMessage || "Organization selection failed. Please try again.";
          }

          /* eslint-disable */
          console.error("error : ", {
            status,
            statusText: error?.response?.statusText,
            message: responseData || error?.message,
          });
        });
    },

    setUser(userData) {
      const session = saveAuthSession(userData, { microsoft: true });

      this.SET_LOGIN_USER(userData);
      this.SET_USER_ORGANIZATIONS({});
      router.replace({
        name: session.passwordChangeRequired ? "changePassword" : "orders",
        params: { lang: session.lang },
      });
    },
  },
};
</script>

<style></style>
